import React from 'react';
import { ThemeProvider } from 'styled-components';
import { theme, GlobalStyles } from './../../elements/SharedElements';
import { Helmet } from 'react-helmet';
import Navigation from './Navigation';
import Footer from './Footer';
import Socials from './Socials';
import { config } from '@fortawesome/fontawesome-svg-core';
import '@fortawesome/fontawesome-svg-core/styles.css';
config.autoAddCss = false;

const Layout = (props) => {

    const title = props.title || "Award Winning NGO"

    return (

        <ThemeProvider theme={theme}>
            <GlobalStyles />
            <Helmet>
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
                <link href="https://fonts.googleapis.com/css2?family=Merriweather:wght@300;400;700;900&family=Roboto+Condensed:wght@300;400;700&display=swap" rel="stylesheet" />
                <title>Za Power House | {title}</title>
                <meta name="description" content="Za Power House is a award winning non-profit organisation that was founded by Zanele Phakathi who felt the need to give back to her community." />
                <meta name="keywords" content="Zanele Phakathi, Za Power House, Non Profit Organization, Soweto, Johannesburg, South Africa" />
                <meta name="google-site-verification" content="olTgtv_r9S8as-V0-NdDLk57yOsCapb0Od-soGGec1U" />
            </Helmet>
            <Navigation />
            {props.children}
            <Socials />
            <Footer />
        </ThemeProvider>
    
    )

}

export default Layout;